<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="closeModel()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="card mt-1">
                <div class="card-body p-4" *ngIf="!rankCheck;else vendorRank">
                    <ng-container *ngIf="!isRFQSENT;else rfqMsg">
                        <p>Purchase Request Sent For <b>FACTORY PROCUREMENT APPROVAL</b></p>
                    </ng-container>
                    <ng-template #rfqMsg>
                        <p>RFQ sent successfully to the supplier  <b>{{vendorName}}</b></p>
                    </ng-template>
                </div>
                <ng-template #vendorRank>
                    <div class="card-body p-4">
                        <p>You have selected <b>{{vendorName}}</b> who is in <b>rank{{rank}}</b></p>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="modal-footer" >
        <a class="btn btn-outline-primary mx-2" *ngIf="rankCheck" (click)="closeModel(true)">Okay</a>
        <a class="btn btn-outline-primary mx-2" (click)="closeModel()">Close</a>
    </div>
</section>
